import { TGetDirectoryRequest, TGetLastdicRequest, TLastdicType, TMaterialList, TMenuType, TReqSearchFile, TResResourcesContent, TResSearch } from "@/module/database";
import request from "@/utils/requset";

//获取左边菜单
export const getFilterMenu = (data: TGetDirectoryRequest) => {
    return request<TGetDirectoryRequest, TMenuType[]>({
        url: '/api/user/resources/getuserauthstrdiclist',
        method: 'GET',
        data,
        /* interceptors: {
            requestInterceptors(req) {
                console.log("===",req);
                return req
            },
            responseInterceptors(result) {
                console.log(":::",result);
                return result
            }
        } */
    })
}

//根据左边菜单id获取年级筛选
export const getLastDicList = (data: TGetLastdicRequest) => {
    return request<TGetLastdicRequest, TLastdicType[]>({
        url: '/api/user/resources/getlastdiclist',
        method: 'GET',
        data,
    })
}

//获取资料库详情
export const getResourcesContent = (data: TGetLastdicRequest) => {
    return request<TGetLastdicRequest, TResResourcesContent>({
        url: '/api/user/resourcescontent/resourcescontentinfov2',
        method: 'GET',
        data,
    })
}

//获取搜索的资料库详情
export const getSearchResources = (data: TReqSearchFile) => {
    return request<TReqSearchFile, TResSearch<TMaterialList[]>>({
        url: 'api/user/resourcescontent/getsearchresourcescontent',
        method: 'POST',
        data,
    })
}